'use strict';

var _module2 = require('./module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_module3.default.directive('fileOnChange', function () {
    return {
        restrict: 'A',
        scope: {
            onChange: '&fileOnChange'
        },
        link: function link(scope, element, attrs) {
            element.on('change', function () {
                scope.$apply(function () {
                    // NOTE: This assumes full jQuery is present, not just Angular's jqLite.
                    var input = element[0];
                    var files = input.files;
                    var file = files[0];
                    scope.onChange({ '$file': file });
                });
            });
            element.on('$destroy', function () {
                return element.off();
            });
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./src/core/fileOnChange.js
// module id = 58
// module chunks = 0 2